module.exports = {
	"SALAD": [
		{
			"Item Name": "Grilled Chicken with Cucumber Salad",
			"Price (Taka)": 123.25
		},
		{
			"Item Name": "Greek Salad",
			"Price (Taka)": 123.25
		},
		{
			"Item Name": "Mexican Street Corn Salad",
			"Price (Taka)": 76.5
		}
	],
	"BREAKFAST": [
		{
			"Item Name": "Breakfast -1\n(Chapati, Egg Omelette &Vegetable Bhaji)",
			"Price (Taka)": 68
		},
		{
			"Item Name": "Continental Breakfast\n(2 Slices of bread, Egg Omelette, Butter & Jam)",
			"Price (Taka)": 85
		},
		{
			"Item Name": "Special Breakfast\n(Chapati, Egg Omelette, Chicken Bhuna & Bhaji)",
			"Price (Taka)": 187
		}
	],
	"MAIN COURSE": [
		{
			"Item Name": "Chicken Tehari /Khichuri /Pulao",
			"Price (Taka)": 187
		},
		{
			"Item Name": "Chinese Set Menu\n(Fried rice, Fried Chicken, Chinese Vegetable)",
			"Price (Taka)": 297.5
		},
		{
			"Item Name": "Continental Food\n(Fried rice, Fish/ Chicken, Sautéed Vegetable)",
			"Price (Taka)": 297.5
		},
		{
			"Item Name": "Standard Lunch/ Dinner\n(Steam rice, Chicken/ Fish Vegetable, Dal)",
			"Price (Taka)": 255
		},
		{
			"Item Name": "Special Lunch/ Dinner\n(Steam rice, Beef / Rupchanda, Vegetable, Dal)",
			"Price (Taka)": 297.5
		},
		{
			"Item Name": "Boiled Chicken and Vegetable",
			"Price (Taka)": 255
		},
		{
			"Item Name": "Steamed Fish with Vegetable\n(Steamed Fish in Bed of Sautéed Vegetable, apple, Lemon grass and White Rice)",
			"Price (Taka)": 297.5
		},
		{
			"Item Name": "Chicken with Noodles and Vegetable\n(Slow Cooked Chicken with Garlic, Ginger, Noddle and Mixed Boiled Vegetable with rice)",
			"Price (Taka)": 255
		},
		{
			"Item Name": "Orange Chicken with Garlic Vegetable\n(Roasted Chicken with Honey and Orange Mixed served with Mixed Sautéed Vegetable with rice)",
			"Price (Taka)": 297.5
		}
	],
	"SNACKS": [
		{
			"Item Name": "Apple and Chicken Sandwich",
			"Price (Taka)": 127.5
		},
		{
			"Item Name": "BBQ Chicken",
			"Price (Taka)": 51
		},
		{
			"Item Name": "BBQ Chicken Sandwich",
			"Price (Taka)": 127.5
		},
		{
			"Item Name": "Beef Burger",
			"Price (Taka)": 187
		},
		{
			"Item Name": "Beef Mughlai Paratha",
			"Price (Taka)": 110.5
		},
		{
			"Item Name": "Brown Bread Sandwich",
			"Price (Taka)": 144.5
		},
		{
			"Item Name": "Chicken Burger",
			"Price (Taka)": 170
		},
		{
			"Item Name": "Chicken Lolipop",
			"Price (Taka)": 29.75
		},
		{
			"Item Name": "Chicken Nuggets",
			"Price (Taka)": 25.5
		},
		{
			"Item Name": "Chicken Sandwich",
			"Price (Taka)": 93.5
		},
		{
			"Item Name": "Chicken Shashlik",
			"Price (Taka)": 127.5
		},
		{
			"Item Name": "Chicken Shawarma Wrap",
			"Price (Taka)": 136
		},
		{
			"Item Name": "Chicken Spring Roll",
			"Price (Taka)": 29.75
		},
		{
			"Item Name": "Club Sandwich",
			"Price (Taka)": 127.5
		},
		{
			"Item Name": "Corn Soup",
			"Price (Taka)": 127.5
		},
		{
			"Item Name": "Dal Puri",
			"Price (Taka)": 17
		},
		{
			"Item Name": "Fried Chicken",
			"Price (Taka)": 93.5
		},
		{
			"Item Name": "Fried Eggs with Tomato and Roasted Pepper SW",
			"Price (Taka)": 85
		},
		{
			"Item Name": "Health Coupon (Package)",
			"Price (Taka)": 165.75
		},
		{
			"Item Name": "Liver Singara",
			"Price (Taka)": 34
		},
		{
			"Item Name": "Mixed Noodles",
			"Price (Taka)": 127.5
		},
		{
			"Item Name": "Mortadella Sandwich",
			"Price (Taka)": 144.5
		},
		{
			"Item Name": "Subway Sandwich",
			"Price (Taka)": 170
		},
		{
			"Item Name": "Vegetable Singara",
			"Price (Taka)": 21.25
		}
	],
	"PASTRY": [
		{
			"Item Name": "Basbousa",
			"Price (Taka)": 68
		},
		{
			"Item Name": "Chocolate Cake / Pastry",
			"Price (Taka)": 85
		},
		{
			"Item Name": "Chocolate Ball",
			"Price (Taka)": 51
		},
		{
			"Item Name": "Chocolate Brownie",
			"Price (Taka)": 127.5
		},
		{
			"Item Name": "Chocolate Lava",
			"Price (Taka)": 63.75
		},
		{
			"Item Name": "Chocolate Mouse",
			"Price (Taka)": 51
		},
		{
			"Item Name": "Chocolate Muffin",
			"Price (Taka)": 51
		},
		{
			"Item Name": "Cookies (250 gm)",
			"Price (Taka)": 161.5
		},
		{
			"Item Name": "Cream Bun",
			"Price (Taka)": 42.5
		},
		{
			"Item Name": "Cup Cake",
			"Price (Taka)": 38.25
		},
		{
			"Item Name": "Custard",
			"Price (Taka)": 51
		},
		{
			"Item Name": "Date Cake Slice",
			"Price (Taka)": 68
		},
		{
			"Item Name": "Fairy Cake",
			"Price (Taka)": 42.5
		},
		{
			"Item Name": "Fruit Platter",
			"Price (Taka)": 102
		},
		{
			"Item Name": "Large Bread",
			"Price (Taka)": 136
		},
		{
			"Item Name": "Lemon/Orange Tart",
			"Price (Taka)": 51
		},
		{
			"Item Name": "Marble Cake",
			"Price (Taka)": 46.75
		},
		{
			"Item Name": "Palimar Cake",
			"Price (Taka)": 42.5
		},
		{
			"Item Name": "Plain Bun",
			"Price (Taka)": 21.25
		},
		{
			"Item Name": "Pyramid Cake",
			"Price (Taka)": 63.75
		},
		{
			"Item Name": "Pudding",
			"Price (Taka)": 106.25
		},
		{
			"Item Name": "Swiss Roll",
			"Price (Taka)": 68
		},
		{
			"Item Name": "jilapi",
			"Price (Taka)": 17
		},
		{
			"Item Name": "Vanilla Cake / Pastry",
			"Price (Taka)": 85
		}
	],
	"ICE CREAM": [
		{
			"Item Name": "Almond Exotic",
			"Price (Taka)": "MRP Price"
		},
		{
			"Item Name": "Black Forest",
			"Price (Taka)": "MRP Price"
		},
		{
			"Item Name": "Chocobar",
			"Price (Taka)": "MRP Price"
		},
		{
			"Item Name": "Cornelli Belgian",
			"Price (Taka)": "MRP Price"
		},
		{
			"Item Name": "Cornelli Classic",
			"Price (Taka)": "MRP Price"
		},
		{
			"Item Name": "Eggo",
			"Price (Taka)": "MRP Price"
		},
		{
			"Item Name": "Exotic Swiss",
			"Price (Taka)": "MRP Price"
		},
		{
			"Item Name": "Macho",
			"Price (Taka)": "MRP Price"
		},
		{
			"Item Name": "Mega",
			"Price (Taka)": "MRP Price"
		},
		{
			"Item Name": "Vanilla Cup",
			"Price (Taka)": "MRP Price"
		}
	],
	"HOT & COLD BEVERAGE": [
		{
			"Item Name": "Milk Coffee",
			"Price (Taka)": 42.5
		},
		{
			"Item Name": "Raw Tea / Milk Tea",
			"Price (Taka)": 25.5
		},
		{
			"Item Name": "Mango Juice - 250ml",
			"Price (Taka)": 17
		},
		{
			"Item Name": "Mineral Water 500ml",
			"Price (Taka)": 17
		},
		{
			"Item Name": "Soft Drinks (300ml)",
			"Price (Taka)": 25.5
		},
		{
			"Item Name": "Watermelon Juice - 250ml",
			"Price (Taka)": 17
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/menu.json
// module id = 863
// module chunks = 0